import {
  BackgroundColors,
  PositiveColors,
  SecondaryColors,
  Shadows,
} from '@picsart/design-system/foundation/colors';
import { FontSizes } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';

const useStyles = createUseStyles(
  {
    root: {
      position: 'relative',
      width: '100%',
      height: 108,
      borderRadius: CornerRadius.r16,
      border: [1, 'solid', BackgroundColors.tint3],
      cursor: 'pointer',
      display: 'flex',
      overflow: 'hidden',
      textAlign: 'start',
      transition: 'all .3s ease',
      background: BackgroundColors.base,
      '&:hover': {
        boxShadow: `${Spacings.s0} ${Spacings.s0} ${Spacings.s16} ${Spacings.s0} rgba(0,0,0,0.2)`,
      },
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      '& > div:first-child': {
        width: '33.333%',
      },
      '& > div:last-child': {
        width: '66.667%',
      },
    },
    titleHolder: {
      width: '100%',
      padding: Spacings.s16,
      color: PositiveColors.text.default,
      display: 'flex',
      flexDirection: 'column',
      alignSelf: 'center',
      gap: Spacings.s8,
    },
    title: {
      fontSize: FontSizes.s16,
      fontWeight: FontWeights.semibold,
    },
    isNew: {
      width: 36,
      height: 16,
      borderRadius: CornerRadius.r24,
      background: SecondaryColors.base.default,
      boxShadow: Shadows.tint2,
      '&>svg': {
        height: '100%',
        width: '100%',
        '&>path': {
          fill: PositiveColors.base.default,
        },
      },
    },
    // Skeleton
    skeletonRoot: {
      extend: 'root',
      borderRadius: CornerRadius.r16,
    },
  },
  {
    name: 'tool',
  },
);

export default useStyles;
